import axios from "axios";
import * as Sentry from "@sentry/react";

const API = axios.create({ baseURL: "http://localhost:5001" });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }

  return req;
});

// Global Axios response error interceptor for Sentry tracking
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Capture API errors to Sentry with context
    Sentry.captureException(error, {
      tags: {
        api_error: true,
        status_code: error.response?.status,
        endpoint: error.config?.url,
      },
      extra: {
        request_url: error.config?.url,
        request_method: error.config?.method,
        response_data: error.response?.data,
        status: error.response?.status,
      },
    });
    return Promise.reject(error);
  }
);

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export const API_BASE_URL = `${BASE_URL}`;
export const DEBUG_ACTIVE = process.env.REACT_APP_DEBUG || true;
/**
 * Derives the WebSocket URL from available environment configuration.
 * Priority: explicit REACT_APP_WEBSOCKET_URL > derived from REACT_APP_API_BASE_URL > dev fallback.
 */
export function getWebSocketUrl() {
  if (process.env.REACT_APP_WEBSOCKET_URL) {
    return process.env.REACT_APP_WEBSOCKET_URL;
  }

  if (process.env.REACT_APP_API_BASE_URL) {
    const base = process.env.REACT_APP_API_BASE_URL;
    const wsProtocol = base.startsWith("https") ? "wss" : "ws";
    return base.replace(/^https?/, wsProtocol) + "/ws";
  }

  return "ws://localhost:8080";
}

export const WEBSOCKET_URL = getWebSocketUrl();
export const fetchPost = (id) => API.get(`/posts/${id}`);
export const fetchPosts = (page) => API.get(`/posts?page=${page}`);
export const fetchPostsByCreator = (name) =>
  API.get(`/posts/creator?name=${name}`);
export const fetchPostsBySearch = (searchQuery) =>
  API.get(
    `/posts/search?searchQuery=${searchQuery.search || "none"}&tags=${
      searchQuery.tags
    }`
  );
export const createPost = (newPost) => API.post("/posts", newPost);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);
export const comment = (value, id) =>
  API.post(`/posts/${id}/commentPost`, { value });
export const updatePost = (id, updatedPost) =>
  API.patch(`/posts/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/${id}`);

export const signIn = (formData) => API.post("/user/signin", formData);
export const signUp = (formData) => API.post("/user/signup", formData);
